import React, { useCallback, useEffect, useState } from 'react';
import PageTitle from '../../../components/atoms/PageTitle';
import ColorTag from '../../../components/atoms/ColorTag';
import ChartComp from '../../../components/molecules/ChartComp';
import chartData from '../../../components/atoms/BarChartData.js';
import AnalyticsCard from '../../../components/atoms/AnalyticsCard';
import ProgressBar from '../../../components/molecules/ProgressBar';
import { connect, useDispatch, useSelector } from 'react-redux';
import { BASE_URL, getRequest, loggedUser_baseURL } from '../../../services/http';
import Alert from '../../../components/atoms/Alert';
import Button from 'components/atoms/Button';
import refreshicon from '../../../assets/svg/refresh.svg';
import moment from 'moment';
import { saveBusinessData, setCountries, storeCommissionConfig } from '../../../redux/app/app.action';

const Home = (props) => {
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(Boolean);
    const [totalBusinesses, setTotalBusinesses] = useState('');
    const [chartData, setChartData] = useState<any>([]);
    const [businessData, setBusinessData] = useState<any>([]);
    const [dailytransactionCount, setDailytransactionCount] = useState<any>([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    // const [startDate, setStartDate] = useState(0); // Initialize as a number
    // const [endDate, setEndDate] = useState(0); // Initialize as a number

    // useEffect(() => {
    //     const currentDate = moment().set({ hour: 9, minute: 0, second: 0 }).valueOf(); // Current day at 09:00:00
    //     const oneMonthAgo = moment().subtract(1, 'months').set({ hour: 9, minute: 0, second: 0 }).valueOf(); // One month ago at 09:00:00

    //     setStartDate(oneMonthAgo); // Set start date as epoch in milliseconds
    //     setEndDate(currentDate); // Set end date as epoch in milliseconds
    // }, [refresh]);

    useEffect(() => {
        const currentDate = moment().endOf('day'); // Adjust to 09:00:00
        const oneMonthAgo = moment().subtract(1, 'months').startOf('day'); // Adjust to 09:00:00

        const start = oneMonthAgo.format('YYYY-MM-DD HH:mm:ss');
        const end = currentDate.format('YYYY-MM-DD HH:mm:ss');

        setStartDate(start);
        setEndDate(end);
    }, [refresh]);

    const getCountries = async () => {
        const res = await getRequest(process.env.REACT_APP_COUNTRIES_URL!);

        if (res?.status === 200) props.setCountries(res?.data.payload);
    }

    const getDailyTransactionCount = async () => {
        const res = await getRequest(`${BASE_URL + loggedUser_baseURL}partner/count`, {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${props.bearerToken}`,
        });

        if (res?.data.responseCode === '00') {
            setDailytransactionCount(res?.data.data);
        } else {
            Alert('error', res?.data.message);
        }
    }

    const getCommissionConfiguration = async () => {
        const res = await getRequest(`${BASE_URL}api/v1/admin/${props.partnerEmail}/details`, {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${props.bearerToken}`,
        });

        if (res?.data.responseCode === '00') {
            props.storeCommissionConfig(res?.data.data);
        } else {
            Alert('error', res?.data.message);
        }
    }
    
    useEffect(() => {
        if (props?.countries?.length === 0 || !props?.countries) {
            getCountries();
        }

        // dateTimeFunc();
        getDailyTransactionCount();
        // getCommissionConfiguration();
    }, [refresh]);

    const datasetOne = (mainData: any[]) => {
        const labels = mainData && mainData.map(item => item.day);
        const data = mainData && mainData.map(item => item.amount);
        const borderWidth = 1
        const borderRadius = 5
        const barPercentage = 0.3
        const categoryPercentage = 1
        const backgroundColor = ['#17191D', '#E7E9F1']
        return { labels, data, borderWidth, borderRadius, barPercentage, categoryPercentage, backgroundColor }
    }

    useEffect(() => {
        if (dailytransactionCount) {
            setChartData([
                { "id": 1, "day": "Mon", "amount": dailytransactionCount.MONDAY },
                { "id": 2, "day": "Tue", "amount": dailytransactionCount.TUESDAY },
                { "id": 3, "day": "Wed", "amount": dailytransactionCount.WEDNESDAY },
                { "id": 4, "day": "Thur", "amount": dailytransactionCount.THURSDAY },
                { "id": 5, "day": "Fri", "amount": dailytransactionCount.FRIDAY },
                { "id": 6, "day": "Sat", "amount": dailytransactionCount.SATURDAY },
                { "id": 7, "day": "Sun", "amount": dailytransactionCount.SUNDAY }
            ])
        }
    }, [dailytransactionCount, refresh]);

    const getSumation = (varObj: any[]) => {
        let sum = varObj.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue;
        }, 0);

        return sum.toFixed(2);
    }

    const params = `?page=1&size=100&startDate=${moment(startDate).format('YYYY-MM-DD HH:mm:ss')}&endDate=${moment(endDate).format('YYYY-MM-DD HH:mm:ss')}`;

    const main_url = `transactions/${props.businessId}${params}`;

    const getBusinessData = async () => {
        setLoading(true);
        const res = await getRequest(`${BASE_URL + loggedUser_baseURL + main_url}`, {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${props.bearerToken}`,
        })

        if (res?.data.status === 'SUCCESS') {
            setBusinessData(res?.data.data);
            props.saveBusinessData(res?.data.data);
            setTotalBusinesses(res?.data?.totalElements);
            setTimeout(() => setLoading(false), 2000);
        } else {
            setLoading(false);
            res?.data.message !== undefined && Alert('error', res?.data.message);
        }
    }

    useEffect(() => {
        if (startDate !== '' && endDate !== '') getBusinessData();
    }, [main_url, refresh]);

    const AmountTransacted = businessData.map(item => item.totalAmountTransacted);
    const totalCommissions = businessData.map(item => item.totalCommissions);
    const totalTransactionCount = businessData.map(item => item.totalTransactionCount);
    const totalAmountTransacted = getSumation(AmountTransacted);
    
    return (
        <>
            <div className='hidden mobile:flex justify-between items-center gap-5 w-full h-fit mb-10'>
                <PageTitle
                    pageTitle='Partner Overview'
                    subTitle='Dashboard'
                    style='!gap-1'
                    pageTitleStyle='!text-[22px]'
                />
                <Button
                    btnType='button'
                    btnText='Refresh'
                    btnStyle='bg-SecondaryAccent5 text-DarkBg3 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                    btnImg={refreshicon}
                    btnImgStyle={`w-4 h-4 ${loading && 'animate-fullRoll'}`}
                    onClick={() => setRefresh(prevState => !prevState)}
                />
            </div>
            <div className='w-full min-h-[90vh] mobile:min-h-[83vh] h-fit flex mobile:flex-col-reverse justify-between tablet:justify-start overflow-hidden mobile:gap-20'>
                <div className='flex flex-col gap-24 w-full desktop:pr-24 pr-8 mobile:pr-0 overflow-scroll'>
                    <div className='flex mobile:flex-col justify-between mobile:gap-5 w-full h-fit flex-shrink-0'>
                        <div className='w-full'>
                            <div className='w-full h-fit flex justify-between items-center gap-5 mobile:hidden'>
                                <PageTitle
                                    pageTitle='Partner Overview'
                                    subTitle='Dashboard'
                                    style='!gap-1'
                                />
                                <Button
                                    btnType='button'
                                    btnText='Refresh'
                                    btnStyle='bg-SecondaryAccent5 text-DarkBg3 text-sm !rounded-lg truncate flex gap-4 ju4tify-center items-center px-5 py-2 font-normal text-base leading-7 rounded-lg truncate'
                                    btnImg={refreshicon}
                                    btnImgStyle={`w-4 h-4 ${loading && 'animate-fullRoll'}`}
                                    onClick={() => setRefresh(prevState => !prevState)}
                                />
                            </div>
                            <div className='grid grid-cols-2 mobile:grid-cols-1 gap-5 w-full'>
                                <div className='w-full bg-Success p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                    <span className='font-normal text-[15px] leading-5'>
                                        Total Commissions
                                    </span>
                                    <span className='font-semibold text-[26px] leading-[31.2px]'>
                                        {Intl.NumberFormat().format(getSumation(totalCommissions))}
                                    </span>
                                </div>

                                <div className='w-full bg-SecondaryAccent p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                    <span className='font-normal text-[15px] leading-5'>
                                        Total Transaction Count
                                    </span>
                                    <span className='font-semibold text-[26px] leading-[31.2px]'>
                                        {Intl.NumberFormat().format(getSumation(totalTransactionCount))}
                                    </span>
                                </div>

                                <div className='w-full bg-Danger3 p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-white'>
                                    <span className='font-normal text-[15px] leading-5'>
                                        Total Transaction Value
                                    </span>
                                    <span className='font-semibold text-[26px] leading-[31.2px]'>
                                        {Intl.NumberFormat().format(totalAmountTransacted)}
                                    </span>
                                </div>

                                <div className='w-full border border-SecondaryAccent p-5 rounded-md min-h-[143px] flex flex-col justify-center gap-2 text-black'>
                                    <span className='font-normal text-[15px] leading-5'>
                                        Invited Businesses
                                    </span>
                                    <span className='font-semibold text-[26px] leading-[31.2px]'>
                                        {totalBusinesses}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex flex-col justify-end'>
                        <PageTitle
                            pageTitle='Daily Transaction Tracker'
                            pageTitleStyle='!text-lg'
                            style='!mb-0'
                        />
                        <ChartComp
                            chartType="bar"
                            propData={chartData}
                            dataset={datasetOne}
                            legend="Amount"
                            style='desktop:!w-4/5 !w-full !h-fit'
                        />
                    </div>
                </div>
                <div className='desktop:p-16 p-8 mobile:p-0 w-[30%] mobile:w-full border-l mobile:border-none flex flex-col gap-32 mobile:gap-16'>
                    <div className='flex flex-col gap-5'>
                        <span className='flex flex-col mobile:flex-row mb-5 mobile:mb-0 gap-0 mobile:gap-5  desktop:justify-between justify-start mobile:justify-between items-start  mobile:items-center'>
                            <PageTitle
                                pageTitle={`${props.userData.partnerBusinessName?.length > 20 ? props.userData.partnerBusinessName.slice(0, 20) + '...' : props.userData.partnerBusinessName}`}
                                pageTitleStyle='!mb-0 !mt-0 !truncate'
                            />
                            <span className='h-fit'>
                                <ColorTag
                                    styleColor={`bg-Green_Accent4 border-Green_Accent rounded-md px-3 py-1 flex gap-1 items-center`}
                                    text='Active'
                                    textColor={`text-Success font-semibold text-sm leading-5`}
                                    BgColor={`bg-Success`}
                                />
                            </span>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business ID</p>
                            <p className='text-base mobile:text-sm'>{`${props.userData.subPartnerId}`}</p>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Business Email</p>
                            <p className='text-base mobile:text-sm'>{`${props.userData.partnerEmail}`}</p>
                        </span>
                        <span className='flex flex-col gap-1 font-normal leading-5'>
                            <p className='text-xs mobile:text-[10px] text-SecondaryAccent'>Country</p>
                            <p className='text-base mobile:text-sm'>{`${props.userData.country}`}</p>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    userData: state.auth?.user_authData,
    partnerEmail: state.auth?.user_authData?.partnerEmail,
    businessId: state.auth?.user_authData?.subPartnerId,
    bearerToken: state.auth?.user_authData?.token.token,
    businessData: state.app.businessData,
    countries: state.app.countries
})

const mapDispatchToProps = dispatch => ({
    saveBusinessData: (data) => dispatch(saveBusinessData(data)),
    setCountries: (data) => dispatch(setCountries(data)),
    storeCommissionConfig: (data) => dispatch(storeCommissionConfig(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Home);